import { render, staticRenderFns } from "./GroupParentSelector.vue?vue&type=template&id=e5656bb6&"
import script from "./GroupParentSelector.vue?vue&type=script&lang=js&"
export * from "./GroupParentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports